var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCommunications01 = function SvgIconCommunications01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_communications-01_svg2__a",
    x1: -6.47,
    x2: 75.35,
    y1: 59.23,
    y2: 11.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_communications-01_svg2__a",
    id: "icon_communications-01_svg2__b",
    x1: -1.06,
    x2: 80.77,
    y1: 68.59,
    y2: 21.26
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_communications-01_svg2__a",
    id: "icon_communications-01_svg2__c",
    x1: 4.08,
    x2: 85.9,
    y1: 77.47,
    y2: 30.14
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_communications-01_svg2__a",
    id: "icon_communications-01_svg2__d",
    x1: 3.99,
    x2: 85.81,
    y1: 77.31,
    y2: 29.98
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_communications-01_svg2__a",
    id: "icon_communications-01_svg2__e",
    x1: 8.09,
    x2: 89.91,
    y1: 84.4,
    y2: 37.07
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_communications-01_svg2__a",
    id: "icon_communications-01_svg2__f",
    x1: -1.43,
    x2: 80.39,
    y1: 67.95,
    y2: 20.62
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M50 24.61c-1.08 0-1.95.88-1.95 1.95s.88 1.95 1.95 1.95 1.95-.88 1.95-1.95-.88-1.95-1.95-1.95",
    style: {
      fill: "url(#icon_communications-01_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.58 59.77c1.08 0 1.95-.88 1.95-1.95s-.88-1.95-1.95-1.95-1.95.88-1.95 1.95.88 1.95 1.95 1.95",
    style: {
      fill: "url(#icon_communications-01_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.62 5.08c-17.58 0-32.02 12.12-33.13 27.39C15.75 33.31 0 45.39 0 61.72c0 6.83 2.7 13.44 7.62 18.68.97 4.01-.21 8.26-3.14 11.19-.56.56-.73 1.4-.42 2.13.3.73 1.01 1.21 1.8 1.21 5.57 0 10.94-2.18 14.93-6.03 3.89 1.32 8.96 2.13 13.59 2.13 17.58 0 32.01-12.12 33.13-27.39 4.09-.18 8.34-.94 11.71-2.08 3.99 3.85 9.36 6.03 14.93 6.03.79 0 1.5-.48 1.8-1.21s.14-1.57-.42-2.13a11.89 11.89 0 0 1-3.14-11.19c4.92-5.24 7.62-11.85 7.62-18.68 0-16.97-16.96-29.3-34.38-29.3ZM34.37 87.11c-4.61 0-9.86-.9-13.38-2.3-.75-.3-1.62-.1-2.16.5a17.54 17.54 0 0 1-8.77 5.2c1.84-3.53 2.31-7.69 1.19-11.62a2 2 0 0 0-.48-.83C6.34 73.5 3.9 67.7 3.9 61.73c0-13.76 13.95-25.39 30.47-25.39 15.6 0 29.3 10.85 29.3 25.39s-13.14 25.39-29.3 25.39Zm54.85-36.4c-.23.23-.39.52-.48.83-1.12 3.94-.65 8.1 1.19 11.62-3.34-.83-6.41-2.62-8.77-5.2-.55-.6-1.41-.8-2.16-.5-3.05 1.21-7.4 2.05-11.51 2.26-.57-7.39-4.25-14.33-10.55-19.48h25.48c1.08 0 1.95-.87 1.95-1.95s-.87-1.95-1.95-1.95H50.94c-4.43-2.26-9.41-3.57-14.54-3.85C37.52 19.37 50.2 9 65.62 9c16.52 0 30.47 11.63 30.47 25.39 0 5.97-2.44 11.77-6.87 16.33Z",
    style: {
      fill: "url(#icon_communications-01_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 55.86H25.39c-1.08 0-1.95.87-1.95 1.95s.87 1.95 1.95 1.95H50c1.08 0 1.95-.87 1.95-1.95s-.87-1.95-1.95-1.95",
    style: {
      fill: "url(#icon_communications-01_svg2__d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 67.58H17.58c-1.08 0-1.95.87-1.95 1.95s.87 1.95 1.95 1.95H50c1.08 0 1.95-.87 1.95-1.95s-.87-1.95-1.95-1.95",
    style: {
      fill: "url(#icon_communications-01_svg2__e)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.42 24.61H57.81c-1.08 0-1.95.87-1.95 1.95s.87 1.95 1.95 1.95h24.61c1.08 0 1.95-.87 1.95-1.95s-.87-1.95-1.95-1.95",
    style: {
      fill: "url(#icon_communications-01_svg2__f)"
    }
  }));
};
export default SvgIconCommunications01;